// src/utils/loadTranslations.ts
import { Language } from "@/translations/supportedLanguages";

export async function loadTranslations(
  lang: Language
): Promise<Record<string, string>> {
  const { default: messages } = await import(
    /* webpackMode: "lazy" */
    `@/translations/translations_${lang}.json`
  );
  return messages;
}
